import { Line } from 'react-chartjs-2';
import { defaultOptions } from '../../utils/chartConfig';

interface LineChartProps {
  data: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      borderColor: string;
      tension?: number;
      fill?: boolean;
    }[];
  };
  height?: string;
}

export default function LineChart({ data, height = '300px' }: LineChartProps) {
  return (
    <div style={{ height }}>
      <Line data={data} options={defaultOptions} />
    </div>
  );
}